// @flow
import UserModel from "src/models/UserModel";
import { entityReducer } from "src/utils/reducerUtils";

export const users = entityReducer({
  name: "users",
  Model: UserModel
});
